import React, { useState } from "react";
import { Outlet } from "react-router";
import NavLinker from "../../../components/NavLinker";
import LockIcon from "@mui/icons-material/Lock";
import loader from "../../../assets/loader.webp";

function Loan() {
  const [loading, setIsLoading] = useState(true);

  if (loading)
    return (
      <div className="w-full h-full flex justify-center items-center">
        <img src={loader} alt="loading..." className="w-12" />
      </div>
    );
  return (
    <div className="flex flex-col gap-4">
      <div className="w-full  flex gap-2 items-center rounded-md  px-4 pt-4">
        <NavLinker to="" end>
          <span className="text-lg font-medium  ">Home</span>
        </NavLinker>
        <NavLinker to="history">
          <span className="text-lg font-medium  ">History</span>
        </NavLinker>
        <NavLinker to="kyc">
          <LockIcon />
          <span className="text-lg font-medium ">KYC</span>
        </NavLinker>
      </div>
      <div>
        <Outlet />
      </div>
    </div>
  );
}

export default Loan;
